import React from 'react';
import styled from 'styled-components';
import { Input as TextInput } from '../../../components/ui';
import { Row } from '../../../components/ui';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import {AsyncSelectElement} from './InputContainer.style';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: ${({flexRow}) => (flexRow ? 'row' : 'column')};
  flex: 1;
  gap: 1rem;
  margin-bottom: 1rem;
  input {
    padding-left: 1rem;
  }
`;

export const InputStyled = styled(TextInput)`
  padding: 1.66rem !important;
  & + label {
    font-weight: 400 !important;
  }
`;

export const SelectElement = styled(Select)<{maxSize?: number}>`
  & + label {
    font-weight: 400 !important;
  }
  & > div {
    max-height: ${({maxSize}) => (maxSize ? `${maxSize}px` : '55px')};
  }
  & div[id*='-input'] {
    background-color: transparent !important;
    color: var(--admin-text-color);
  }
  & div[id*='-listbox'] {
    height: inherit !important;
    max-height: inherit !important;
    padding: 10px 0 !important;
  }
`;

export const SelectElementWrapper = styled.div`
  .input-field > & > label {
    margin-top: -5px;
    width: 100%;
  }
  .input-field > & {
    margin-top: -20px;
  }
  .invalid + .helper-text {
    color: red;
  }
`;

export const SelectStyled = React.forwardRef<any, any>((props, ref) => (
  <SelectElementWrapper>
    {!!props.label && <label>{props.label}</label>}
    <SelectElement
      {...props}
      ref={ref}
      className={`${props.className} select-styled`}
    />
    {!!props.error && (
      <span className="helper-text" data-error={props.error}>
        {props.error}
      </span>
    )}
  </SelectElementWrapper>
));
SelectStyled.displayName = 'SelectStyled';

export const AsyncSelectStyled = (props: any) => (
  <>
    {!!props.label && <label>{props.label}</label>}
    <AsyncSelectElement {...props} />
    {!!props.error && (
      <span className="helper-text" data-error={props.error} role="alert">
        {props.error}
      </span>
    )}
  </>
);

export const InputMaskStyled = (props: any) => (
  <InputMaskWrapper
    className={`input-field ${
      props?.s || props?.m || props?.l || props?.xl
        ? `col s${props.s} m${props.m} l${props.l} xl${props.xl}`
        : ''
    }`}
    style={{width: '100%', marginTop: 'none'}}>
    {!!props.label && <label>{props.label}</label>}
    <InputMaskElement {...props} />
    {!!props.error && (
      <span className="helper-text" data-error={props.error} role="alert">
        {props.error}
      </span>
    )}
  </InputMaskWrapper>
);

// O visual vinha do Materialize, que estilizava `input` globalmente. Fora do
// admin nao ha esse CSS, e o campo virava um input cru com 1.66rem de padding.
// Estes valores acompanham o Input de components/ui.
export const InputMaskElement = styled(InputMask)`
  background: #fff;
  border: 1px solid hsl(var(--input, 214 32% 91%));
  border-radius: 6px;
  box-sizing: border-box;
  font-size: 14px;
  height: 36px;
  padding: 0 12px;
  width: 100%;

  &:focus {
    outline: none;
    border-color: #006bf3;
    box-shadow: 0 0 0 1px #006bf3;
  }

  & + label {
    font-weight: 400 !important;
  }
`;

export const InputMaskWrapper = styled.div`
  margin-top: 0 !important;
  padding: 0 4px;

  input {
    margin-top: 2px !important;
  }

  label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 4px;
    position: inherit !important;
    transform: none !important;
  }

  .helper-text {
    color: #c20808;
    display: block;
    font-size: 12px;
    margin-top: 4px;
  }
`;

const ButtonElement = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.66rem !important;
  & + label {
    font-weight: 400 !important;
  }
`;

export const ButtonStyled = (props: any) => (
  <ButtonElement {...props} className={`${props.className} btn`} />
);
